'use client';

import { useMediaQuery, useTheme } from '@mui/material';

export type Device = 'mobile' | 'tablet' | 'desktop';

export function useGetDevice(): Device {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
}
